import { isDev } from '../config/env';

const MARKETSMART_EMAIL_DOMAIN = '@imarketsmart.com';
/** MarketSmart internal org - use with getUsers(MARKETSMART_ORG_ID) */
export const MARKETSMART_ORG_ID = 1;

/** Keep in sync with backend LOGIN_AS_AUTHORIZED_EMAILS (engineering use). */
export const LOGIN_AS_AUTHORIZED_EMAILS = new Set([
  'lrodriguez@imarketsmart.com',
  'rhanson@imarketsmart.com',
  'jyergo@imarketsmart.com',
  'etran@imarketsmart.com',
  'hwarren@imarketsmart.com',
  'fbasier@imarketsmart.com',
  'ndelgiorno@imarketsmart.com',
]);

type UserLike = {
  email?: string | null;
  org_id?: string | number | null;
  deleted_at?: string | null;
};

export const hasMarketSmartEmail = (email?: string | null): boolean =>
  !!email?.toLowerCase().endsWith(MARKETSMART_EMAIL_DOMAIN);

export const isSuperadmin = (user?: UserLike | null): boolean => {
  if (!user) return false;

  if (hasMarketSmartEmail(user.email)) return true;

  const orgId = Number(user.org_id);
  return Number.isFinite(orgId) && orgId === MARKETSMART_ORG_ID;
};

export const isLoginAsAuthorized = (user?: UserLike | null): boolean => {
  if (!isSuperadmin(user)) return false;
  if (isDev()) return true;
  const email = user?.email?.toLowerCase();
  return !!email && LOGIN_AS_AUTHORIZED_EMAILS.has(email);
};

/** Soft-deactivated staff should not be selectable as CSM. */
export const isActiveUser = (user?: UserLike | null): boolean =>
  !!user && !user.deleted_at;
